import { render, staticRenderFns } from "./StatusAutomations.vue?vue&type=template&id=b1ef43c8&scoped=true&"
import script from "./StatusAutomations.vue?vue&type=script&lang=js&"
export * from "./StatusAutomations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ef43c8",
  null
  
)

export default component.exports